import { EMOTIONS } from "@/lib/emotions";
import { GUIDE, GUIDE_STEPS } from "@/lib/guide";
import { EmotionFigure } from "@/components/Brand";
import { useRemanso } from "@/context/RemansoContext";

const EmotionCard = ({ e }) => {
  const { bound, moods, toggleMood } = useRemanso();
  const g = GUIDE[e.id];
  const marked = moods.some((m) => m.startsWith(`${e.id}:`) || m === e.id);
  return (
    <article id={`guia-${e.id}`} className="scroll-mt-4 rounded-[24px] bg-hoja border border-linea p-5" data-testid={`guide-card-${e.id}`}>
      <div className="flex items-center gap-4">
        <EmotionFigure id={e.id} height={96} testId={`guide-figure-${e.id}`} />
        <div className="min-w-0">
          <p className="font-serif text-[24px] leading-tight text-tinta flex items-center gap-2">
            <span className="h-3 w-3 rounded-full" style={{ background: e.color }} aria-hidden="true" />{e.name}
          </p>
          <p className="font-serif text-[17px] leading-snug text-tinta mt-1.5">{g.lead}</p>
        </div>
      </div>
      <p className="text-[14px] text-sec mt-4"><span className="text-tinta font-medium">En el cuerpo:</span> {g.body}</p>
      <p className="text-[14px] text-sec mt-2">{g.when}</p>
      <p className="text-[13px] text-meta mt-3">
        De suave a intensa: {e.nuances.map((n, i) => `${n}${g.hints[i] ? ` (${g.hints[i]})` : ""}`).join(", ")}.
      </p>
      {bound && (
        <div className="flex flex-wrap gap-2 mt-3">
          {e.nuances.map((n, i) => {
            const mood = `${e.id}:${n}`;
            const on = moods.includes(mood);
            return (
              <button key={mood} type="button" aria-pressed={on} onClick={() => toggleMood(mood)}
                className={`chip text-[13px] ${on ? "active" : ""}`} data-testid={`guide-nuance-${e.id}-${i}`}>
                <span className="h-2.5 w-2.5 rounded-full" style={{ background: e.color, opacity: 0.45 + i * 0.275 }} aria-hidden="true" /> {n}
              </button>
            );
          })}
        </div>
      )}
      {bound && marked && <p className="text-[13px] text-acento-texto mt-3" data-testid={`guide-marked-${e.id}`}>Marcado en tu entrada de hoy</p>}
    </article>
  );
};

export const EmotionGuide = () => {
  const { bound, chooseRoute, closeInfo } = useRemanso();
  return (
    <div className="space-y-8" data-testid="emotion-guide">
      <p className="text-[15px] text-sec leading-relaxed">
        Nombrar lo que sientes ayuda a mirarlo con más calma. No hay respuestas correctas: puede ser más de una emoción a la vez, y puede cambiar mientras escribes.
      </p>
      <section id="guia-raro" className="scroll-mt-4 rounded-[24px] bg-superficie p-5" data-testid="guide-section-raro">
        <h3 className="font-serif text-[22px] leading-tight text-tinta">Si solo sabes que te sientes raro</h3>
        <ol className="mt-4 space-y-3">
          {GUIDE_STEPS.map((s, i) => (
            <li key={s} className="flex gap-3 text-[15px] text-tinta leading-relaxed">
              <span className="font-hand text-[22px] leading-none text-acento-texto pt-0.5 shrink-0">{i + 1}.</span><span>{s}</span>
            </li>
          ))}
        </ol>
        {bound && (
          <button type="button" className="btn-secondary mt-5" onClick={() => { chooseRoute("cuerpo"); closeInfo(); }} data-testid="guide-write-body-button">
            Escribir desde el cuerpo
          </button>
        )}
      </section>
      <div className="space-y-4">
        {EMOTIONS.map((e) => <EmotionCard key={e.id} e={e} />)}
      </div>
      <p className="text-[13px] text-meta leading-relaxed" data-testid="guide-footnote">
        Estas descripciones son orientativas: cada persona siente distinto. Pensive no adivina lo que sientes; lo nombras tú.
      </p>
    </div>
  );
};
